import Search from '@baseball-systems/MasterSearch';
import { CLE_ORG_OR_CLUB_ID } from './constants';
import { TICKER_GAME_TYPE_OPTIONS_LANDING_PAGE } from '@gameview/lib/vue/constants.js';

window.vueComponents = () => {
  return {
    search: Search,
  };
};

window.CreateGVTicker = (placeholder) => {
  new Vue({
    el: placeholder,
    components: {
      'root-component': () => import('@gameview/lib/vue/components/GameviewTicker/GameviewTicker.vue'),
    },
    render: (h) =>
      h('root-component', {
        props: {
          organization: {
            MLAbbrev: 'CLE',
            Rank: CLE_ORG_OR_CLUB_ID,
            ClubId: CLE_ORG_OR_CLUB_ID,
          },
          forceShowCleFilter: true,
          showCollapseButton: false,
          gameTypeOptionsProp: TICKER_GAME_TYPE_OPTIONS_LANDING_PAGE,
        },
      }),
  });
};

window.CreateRosterBoard = (preSelectedView, isFrontOffice, canAccessPD) => {
  new Vue({
    el: '#roster-board-container',
    components: {
      'root-component': () => import('dv/league/Vue/components/RosterBoard/DvRosterBoard.vue'),
    },
    render(h) {
      return h('root-component', {
        props: {
          preSelectedView: preSelectedView,
          preSelectedCol: isFrontOffice ? 'MetaRoleF' : 'Age',
          isFrontOffice: isFrontOffice,
          canAccessPD: canAccessPD,
        },
      });
    },
  });
};

window.CreateDraftTable = (placeholder) => {
  new Vue({
    el: placeholder,
    components: {
      'root-component': () =>
        import('dv/scouting_new/vue/components/draft-tools/homePageDraftTable/HomePageDraftTable.vue'),
    },
    render(h) {
      return h('root-component');
    },
  });
};

window.CreatePlayoffOddsTable = (placeholder) => {
  new Vue({
    el: placeholder,
    components: {
      'root-component': () => import('dv/dview/lib/Vue/playoffOddsWidget/PlayoffOddsWidget.vue'),
    },
    render(h) {
      return h('root-component');
    },
  });
};
